
import { useState, useEffect, useRef } from "react";
import { X } from "lucide-react";

interface FIDSHeaderProps {
  title: string;
  searchTerm?: string;
  onSearchChange?: (value: string) => void;
}

export function FIDSHeader({ title, searchTerm = "", onSearchChange }: FIDSHeaderProps) {
  const [time, setTime] = useState(new Date());
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // PNG time is UTC+10
  const pngTime = new Date(time.toLocaleString("en-US", { timeZone: "Pacific/Port_Moresby" }));
  const hours = pngTime.getHours().toString().padStart(2, "0");
  const minutes = pngTime.getMinutes().toString().padStart(2, "0");
  const day = pngTime.getDate().toString().padStart(2, "0");
  const month = (pngTime.getMonth() + 1).toString().padStart(2, "0");
  const year = pngTime.getFullYear();

  return (
    <div className="w-full flex items-center justify-between px-4 md:px-6 py-3 gap-3" style={{ backgroundColor: "#000000" }}>
      <div className="flex items-center gap-4 md:gap-6 shrink-0">
        <div className="hidden sm:flex items-center gap-3">
          <img src="/NAC_logo.png" alt="NAC Logo" className="h-8 w-auto" />
          <span className="text-white font-bold text-sm md:text-base hidden md:inline">
            Port Moresby Jacksons International Airport
          </span>
        </div>

        <div className="text-right font-mono">
          <div className="text-white font-bold text-2xl md:text-3xl leading-none tracking-wider">
            {hours}:{minutes}
          </div>
          <div className="text-white/80 text-xs leading-tight">
            {day}-{month}-{year}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {onSearchChange && (
          <div className="relative">
            <input
              ref={inputRef}
              type="text"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search flight, origin or destination…"
              className="w-[180px] md:w-[260px] h-9 rounded-md px-3 pr-8 text-sm text-white placeholder:text-white/40 outline-none"
              style={{
                backgroundColor: "#0a0f2c",
                border: "1px solid #00c8d7",
              }}
            />
            {searchTerm && (
              <button
                onClick={() => onSearchChange("")}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-white/50 hover:text-white"
                aria-label="Clear search"
              >
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        )}
        <span className="text-white font-bold text-lg md:text-xl tracking-wide shrink-0">{title}</span>
      </div>
    </div>
  );
}
